/** @jsxImportSource @emotion/react */
import { Typography, createStyles, useTheme } from '@quickbit/qb-design-system';
import { Link } from 'react-router-dom';

export const PageNotFound = () => {
  const styles = useStyles();
  const { palette } = useTheme();
  return (
    <section css={styles.container}>
      <div css={styles.content}>
        <Typography variant="heading2" color={palette.danger.default}>
          404
        </Typography>
        <Typography variant="heading1">
          Oops! <br />
          This is not the page
          <br /> you&apos;re looking for.
        </Typography>
        <div css={styles.body}>
          <Typography variant="captionSmallMedium" color={palette.grey.default}>
            &bull; The address must be typed incorrectly.
            <br /> &bull; It may be a broken or outdated link.
          </Typography>

          <Typography variant="body" color={palette.grey.default}>
            Go back to our &nbsp;
            {/* TODO: we need to add Link component with all the common styling in our design-system */}
            <Link css={styles.navigationLink} to="/" replace>
              homepage
            </Link>
            &nbsp; for a fresh start.
          </Typography>
        </div>
      </div>
    </section>
  );
};

const useStyles = createStyles(({ spacing, palette }) => ({
  container: {
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  content: {
    paddingLeft: spacing.xxs,
    borderLeft: `2px solid ${palette.grey.x200}`,
  },
  body: {
    marginBlock: spacing.xxs,
    '& > p': {
      marginTop: spacing.xxs,
    },
  },
  navigationLink: {
    textDecoration: 'none',
    color: palette.primary.default,
  },
}));
